export default __webpack_public_path__ + "static/media/user-circle-redflag.0f7c11c0.svg";